import React from 'react';

const PrintHeader = () => {
  return (
    <div className='w-[105.3mm] h-[35mm] ml-[4mm] nob_border grid grid-rows-[5mm_13mm_6mm_10mm] grid-cols-[6mm_1fr] text-sm'>
      {/* 공급자 열 */}
      <div className='page_center r_border row-span-5'>공급자</div>

      {/* 일련번호, 전화번호 */}
      <div className='grid grid-cols-[20mm_36mm_10mm_31.5mm] b_border'>
        <div className='page_center r_border'>일련번호</div>
        <div className='page_center r_border'>2024/07/05-2</div>
        <div className='page_center r_border'>tel</div>
        <div className='page_center'>07082325822</div>
      </div>

      {/* 사업자등록 번호, 성명 */}
      <div className='grid grid-cols-[20mm_36mm_10mm_31.5mm] b_border'>
        <div className='page_center r_border'>사업자등록 번호</div>
        <div className='page_center r_border'>631-88-00743</div>
        <div className='page_center r_border'>성명</div>
        <div className='page_center'>남궁장</div>
      </div>

      {/* 상호 */}
      <div className='grid grid-cols-[20mm_78mm] b_border'>
        <div className='page_center border-r border-black'>상호</div>
        <div className='page_center'>(주)제이브이코리아</div>
      </div>

      {/* 주소 */}
      <div className='grid grid-cols-[20mm_78mm]'>
        <div className='page_center r_border'>주소</div>
        <div className='page_center'>경기도 수원시 권선구 산업로 115번길 50(고색동)</div>
      </div>
    </div>
  );
};

export default PrintHeader;
